import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MenuCard = ({ module, route, icon, name }) => {
  return (
    <Card className='m-3 index-card' cypressid={`${module}`}>
      <Card.Body className='text-center'>
        {route.includes("https://") ? (
          <a href={route} target='_blank' rel='noreferrer'>
            <FontAwesomeIcon className='font-icon mb-2' icon={icon} style={{ color: "#147995", fontSize: "500%" }} />
            <br />
            <span style={{ color: "#5fa7be" }}>{name}</span>
          </a>
        ) : (
          <Link to={{ pathname: route, state: { module, route, icon, name } }} className='hyperlink'>
            <FontAwesomeIcon className='font-icon mb-2' icon={icon} style={{ color: "#147995", fontSize: "500%" }} />
            <br />
            <span style={{ color: "#5fa7be" }}>{name}</span>
          </Link>
        )}
      </Card.Body>
    </Card>
  );
};

export default MenuCard;
